import { Injectable } from "@angular/core";
import firebase from "firebase/app";

/*
  Generated class for the NotesProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NotesProvider {
	public notesRef: firebase.database.Reference;
	notesEmpty: any = true;

	constructor() {}

	initNotes() {
		this.notesRef = firebase
			.database()
			.ref(`/userProfile/${firebase.auth().currentUser.uid}/notes`);
	}

	createNote(
		noteID: string,
		noteContent: string
	): firebase.database.ThenableReference {
		return this.notesRef.push({
			id: noteID,
			content: noteContent
		});
	}

	// updateNote(
	//   noteID: string,
	//   noteKey: string,
	//   noteContent: string

	// ): firebase.database.ThenableReference {

	//   var note = firebase.database().ref(`/userProfile/${firebase.auth().currentUser.uid}/notes/${noteKey}`);

	//   note.update({ id: noteID, content: noteContent }).then(result => {

	//   });
	// }
	updateNote(
		noteID: string,
		noteKey: string,
		noteContent: string
	): PromiseLike<any> {
		return this.notesRef
			.child(`${noteKey}`)
			.update({ id: noteID, content: noteContent })
			.then(result => {
				console.log(`${noteKey} has been updated successfully`);
			});
	}

	getNoteList(): firebase.database.Reference {
		return this.notesRef;
	}

	getNoteDetail(noteID: string): firebase.database.Reference {
		return this.notesRef.child(noteID);
	}

	getTheNote(url): Promise<any> {
		return new Promise((resolve, reject) => {
			this.getNoteList().on("value", dataSnapshot => {
				dataSnapshot.forEach(childSnapshot => {
					if (childSnapshot.child("id").val() === url) {
						//save original note
						let noteContent = this.wrapURLS(childSnapshot.child("content").val());
	          resolve(noteContent);
	          return;
					}
	      });
	      resolve("You have no saved personal notes for this guideline. Select EDIT to add personal notes")
			});
		});
	}

	wrapURLS(text: string): string {
		var url_pattern = /(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}\-\x{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?/ig;
  
		return text.replace(url_pattern, (url) => {
			var protocol_pattern = /^(?:(?:https?|ftp):\/\/)/i;
			var href = protocol_pattern.test(url) ? url : 'http://' + url;
			return '<a href="' + href + '" target="_blank">' + url + '</a>';
		});
	}
}



// WEBPACK FOOTER //
// ./src/providers/notes/notes.ts